import { Flex, Hide } from '@chakra-ui/react';

import { Header } from '../../components';

import { PaymentCreditCard } from './PaymentCreditCard';
import { PaymentMyProducts } from './PaymentMyProducts';

const ROOT_ENTITY = 'checkout/payment';

export const Payment = () => {
  return (
    <Flex
      flexDir="column"
      w="full"
      p={{ base: 0, lg: 5 }}
      maxH="100dvh"
      h="100%"
    >
      <Header
        currentStep={3}
        rootEntity={ROOT_ENTITY}
        cart={<PaymentMyProducts />}
      />

      <Flex
        gap={5}
        flexDir={{ base: 'column', lg: 'row' }}
        p={{ base: 4, lg: 0 }}
      >
        <Flex flexDir="column" gap={6} w="full">
          <PaymentCreditCard />
        </Flex>

        <Hide below="lg">
          <PaymentMyProducts />
        </Hide>
      </Flex>
    </Flex>
  );
};
